// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import { Loader as MapLoader } from '@googlemaps/js-api-loader';
import mapStyles from './_mapStyles';
import { forEach as _forEach } from 'lodash-es';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------
const { googleData } = window;


const mapLoader = new MapLoader({
  apiKey: googleData.google_api_key,
  version: 'weekly',
});

const baseClass = 'location-map';
var markers = [];
var iterator = 0;
let iconPath = '';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class LocationMap {
  constructor(el) {
    this.waypoint = null;
    this.gm = null;
    this.map = null;
    this.coords = null;
    this.center = null;
    this.infoWindow = null;
    this.el = el;
    this.mapMarker = $(el);
    this.$infoWindowContent = $(el).find(`.${baseClass}__info-window-content`);
    this.$inner = $(el).find(`.${baseClass}__inner`);
    this.markers = [];

    this.initWaypoint(el);
  }

  createMarker() {
    _forEach(this.mapMarker, (item, index) => {
      this.coords = {
        lat: parseFloat(item.dataset.lat),
        lng: parseFloat(item.dataset.lng),
      };

      // let isActive = false;

      let marker = new google.maps.Marker({
        id: `marker-${parseInt(index + 1)}`,
        isMain: true,
        position: this.coords,
        map: this.map,
        icon: item.dataset.marker,
        draggable: false,
      });

      markers.push(marker);

      iterator++;
    });
  }

  mapCenter() {
    _forEach(this.mapMarker, (item) => {
      if (item.classList.contains('is-center')) {
        this.center = {
          lat: parseFloat(item.dataset.lat),
          lng: parseFloat(item.dataset.lng),
        };
      }
    });
  }

  initWaypoint(el) {
    this.waypoint = new IntersectionObserver((o) => {
      if (o[0].isIntersecting) {
        this.initMap(el);
        this.waypoint.disconnect();
      }
    }, {
      rootMargin: '125% 0px',
      threshold: 0,
    });
    this.waypoint.observe(this.el);
  }


  initMap() {
    mapLoader.load().then(() => {
      this.gm = window.google.maps;
      this.mapCenter();
      this.map = new this.gm.Map(this.$inner[0], {
        center: this.center,
        zoom: 16,
        disableDefaultUI: true,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: mapStyles,
      });

      this.createMarker();
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new LocationMap(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
